(function() {
  const config = window.MudifyAddonPromoBadgeConfig || {};
  const ADDON_PROMO_BADGE_URL = String(config.imageUrl || "").trim();
  const ADDON_PROMO_BADGE_ALT = String(config.altText || "Discount badge").trim();
  const ADDON_PROMO_BADGE_WIDTH = "72px";
  const ADDON_PROMO_BADGE_TOP = "-3px";
  const ADDON_PROMO_BADGE_MARGIN_LEFT = "8px";
  const GROUP_TITLE_TARGETS = ["MORE ADD-ONS"];
  function isNewPromoBadge(wrapper) {
    if (!wrapper) return false;
    return wrapper.dataset.mudifyAddonPromoBadge === "true";
  }
  function buildPromoBadge(topOffset = ADDON_PROMO_BADGE_TOP) {
    if (!ADDON_PROMO_BADGE_URL) return null;
    const wrapper = document.createElement("span");
    wrapper.className = "wrapper-icon-badge badge_";
    wrapper.dataset.mudifyAddonPromoBadge = "true";
    wrapper.style.display = "inline-flex";
    wrapper.style.alignItems = "center";
    wrapper.style.marginLeft = ADDON_PROMO_BADGE_MARGIN_LEFT;
    wrapper.style.position = "relative";
    wrapper.style.top = topOffset;
    wrapper.style.verticalAlign = "top";
    wrapper.style.flexShrink = "0";
    const image = document.createElement("img");
    image.src = ADDON_PROMO_BADGE_URL;
    image.alt = ADDON_PROMO_BADGE_ALT;
    image.loading = "lazy";
    image.decoding = "async";
    image.style.width = ADDON_PROMO_BADGE_WIDTH;
    image.style.height = "auto";
    image.style.display = "block";
    wrapper.appendChild(image);
    return wrapper;
  }
  function fixApoTitles() {
    const titles = document.querySelectorAll(".apo-title");
    if (!titles.length) {
      setTimeout(fixApoTitles, 400);
      return;
    }
    titles.forEach((title) => {
      const fullText = title.innerText.trim().toUpperCase();
      const targets = [
        "FRONT BRAKE LINES",
        "EXTENDED BRAKE LINES",
        "DIFF DROP",
        "REAR BRAKE LINES",
        "FRONT BUMP STOPS",
        "TOP HAT KIT",
        "REAR BUMP STOPS",
        "BUMP STOPS"
      ];
      const match = targets.find((t) => fullText.includes(t));
      if (!match) return;
      if (match === "DIFF DROP") {
        title.style.fontSize = "13px";
        title.style.lineHeight = "1";
        title.style.letterSpacing = "0";
      }
      const existingBadge = title.querySelector(".wrapper-icon-badge");
      if (isNewPromoBadge(existingBadge)) return;
      const promoBadge = buildPromoBadge();
      if (!promoBadge) return;
      title.querySelectorAll("p").forEach((p) => p.remove());
      title.textContent = match;
      title.appendChild(promoBadge);
    });
  }
  function fixAddonGroupTitle() {
    const groups = document.querySelectorAll(".apo-custom-title-group");
    if (!groups.length) {
      setTimeout(fixAddonGroupTitle, 500);
      return;
    }
    groups.forEach((group) => {
      const titleEl = group.querySelector(".apo-group-title") || Array.from(group.querySelectorAll("*")).find((el) => {
        const normalized = el.textContent.replace(/\s+/g, " ").trim().toUpperCase();
        const hasTarget = GROUP_TITLE_TARGETS.some((target) => normalized.includes(target));
        if (!hasTarget) return false;
        return !Array.from(el.children).some((child) => {
          const childText = child.textContent.replace(/\s+/g, " ").trim().toUpperCase();
          return GROUP_TITLE_TARGETS.some((target) => childText.includes(target));
        });
      });
      if (!titleEl) return;
      const existingBadge = titleEl.querySelector(".wrapper-icon-badge");
      const moreAddonsBadge = buildPromoBadge("0px");
      if (!moreAddonsBadge) return;
      if (existingBadge) {
        if (isNewPromoBadge(existingBadge)) return;
        existingBadge.replaceWith(moreAddonsBadge);
      } else {
        titleEl.appendChild(moreAddonsBadge);
      }
      titleEl.style.whiteSpace = "nowrap";
      titleEl.style.display = "inline-flex";
      titleEl.style.alignItems = "center";
    });
  }
  function applyAddonPromoBadges() {
    fixApoTitles();
    fixAddonGroupTitle();
  }
  window.MudifyAddonPromoBadges = {
    apply: applyAddonPromoBadges
  };
  document.addEventListener("DOMContentLoaded", applyAddonPromoBadges);
})();
